/* 2026 WilderdijkDynamics. Requests use the signed Shopify proxy and the current variant. */
(function () {
  'use strict';
  if (window.wdRestockRequestBound) return;
  window.wdRestockRequestBound = true;
  function selectedVariant(form) {
    var productForm = document.getElementById(form.dataset.wdForm || '');
    var input = productForm && productForm.querySelector('[name="id"]');
    return String(input ? input.value : form.dataset.variantId || '');
  }
  async function readJson(response) {
    if (!(response.headers.get('content-type') || '').includes('application/json')) throw new Error('RESTOCK_UNAVAILABLE');
    var result = await response.json();
    if (!response.ok) throw new Error(result.error || 'RESTOCK_UNAVAILABLE');
    return result;
  }
  function resetConfirmation(form) {
    var content = form.closest('[data-wd-restock-content]');
    if (!content) return;
    content.querySelector('[data-wd-restock-heading]').textContent = form.dataset.title;
    content.querySelector('[data-wd-restock-intro]').textContent = form.dataset.intro;
    content.querySelector('[data-wd-restock-entry]').hidden = false;
    content.querySelector('[data-wd-restock-confirmation]').hidden = true;
    content.querySelector('[data-wd-restock-confirm-email]').textContent = '';
    form.querySelector('[data-wd-restock-status]').textContent = '';
  }
  function showConfirmation(form, email) {
    var content = form.closest('[data-wd-restock-content]');
    if (!content) return;
    var heading = content.querySelector('[data-wd-restock-heading]');
    heading.textContent = form.dataset.confirmTitle;
    content.querySelector('[data-wd-restock-intro]').textContent = form.dataset.confirmIntro;
    content.querySelector('[data-wd-restock-confirm-email]').textContent = email;
    content.querySelector('[data-wd-restock-entry]').hidden = true;
    content.querySelector('[data-wd-restock-confirmation]').hidden = false;
    heading.focus({ preventScroll: true });
  }
  document.addEventListener('wd:restock-variant-changed', function (event) {
    if (event.target.matches('[data-wd-restock-form]')) resetConfirmation(event.target);
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-wd-restock-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    var status = form.querySelector('[data-wd-restock-status]');
    var button = form.querySelector('button[type="submit"]');
    var id = selectedVariant(form);
    if (!/^[1-9]\d{0,19}$/.test(id)) { status.textContent = form.dataset.invalidVariant; return; }
    if (form.dataset.available === 'true') { status.textContent = form.dataset.availableMessage; return; }
    if (window.WDContactEmail) window.WDContactEmail.validatePhone(form.elements.phone);
    if (!form.reportValidity()) return;
    var email = form.elements.email.value.trim();
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = form.dataset.sending;
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      var endpoint = root.replace(/\/?$/, '/') + 'apps/wd-account/restock';
      var options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal };
      var session = await readJson(await fetch(endpoint, Object.assign({}, options, { headers: { Accept: 'application/json' } })));
      if (!session.enabled) throw new Error('RESTOCK_PAUSED');
      // A shopper may change variant while the token request is in flight.
      if (selectedVariant(form) !== id) throw new Error('VARIANT_CHANGED');
      await readJson(await fetch(endpoint, Object.assign({}, options, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-WD-Wishlist-Token': session.csrfToken },
        body: JSON.stringify({ variantId: id, email: email, phone: form.elements.phone.value.trim(), website: form.elements.website.value })
      })));
      if (window.WDContactEmail) window.WDContactEmail.remember(email);
      if (selectedVariant(form) === id) { status.textContent = form.dataset.success; showConfirmation(form, email); }
    } catch (error) {
      if (selectedVariant(form) === id) status.textContent = error.message === 'ALREADY_AVAILABLE' ? form.dataset.availableMessage : error.message === 'INVALID_EMAIL' ? form.dataset.invalidEmail : form.dataset.unavailable;
    } finally {
      clearTimeout(timer);
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
      button.disabled = form.dataset.available === 'true' || !/^[1-9]\d{0,19}$/.test(selectedVariant(form));
    }
  });
})();
